import React from "react";
import PropTypes from "prop-types";

function Brand() {
  return (
    <div className="brand" aria-label="Site">
      <span className="brand-badge" />
      <span>Shubhajeet Pradhan</span>
    </div>
  );
}

function NavLinks() {
  return (
    <div className="nav-links">
      <a href="#projects" className="nav-link">
        Projects
      </a>
      <a href="#experience" className="nav-link">
        Experience
      </a>
      <a href="/resume.pdf" className="btn">
        Resume
      </a>
    </div>
  );
}

function Header({ children }) {
  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Brand />
          <NavLinks />
          {children}
        </nav>
      </div>
    </header>
  );
}

Header.propTypes = {
  children: PropTypes.node,
};

Header.defaultProps = {
  children: null,
};

export default Header;
